import { useCallback } from 'react';

import { useAuth } from '@clerk/clerk-react';

export const useGetAuthToken = () => {
	const { getToken } = useAuth();

	return useCallback(() => {
		return getToken({ template: 'trustform' });
	}, [getToken]);
};
